module.exports = __webpack_public_path__ + "static/media/digha-beach.904e5532.jpg";